// extracted by mini-css-extract-plugin
export var statItem = "_fe-1";
export var statsRow = "_fe-0";